var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFetchData',{attrs:{"action":_vm.fetchData},scopedSlots:_vm._u([{key:"default",fn:function(fetchDataProps){return [(fetchDataProps.status.resolved)?_c('BaseVeeForm',{attrs:{"action":_vm.onSend},scopedSlots:_vm._u([{key:"default",fn:function(formProps){return [_c('div',[_c('div',{staticClass:"bg-white p-4 rounded-t space-y-4"},[_c('BaseFormSelectFieldWithValidator',{attrs:{"validator":{
                name: 'third party service',
                vid: 'third_party_service_id',
                rules: {
                  required: true,
                },
              },"field":{
                id: 'third_party_service',
                label: 'From',
                required: true,
                defaultOptionLabel: 'Select sending service...',
                options: _vm.thirdPartyServiceOptions,
              },"disabled":formProps.isPending},model:{value:(_vm.formData.third_party_service_id),callback:function ($$v) {_vm.$set(_vm.formData, "third_party_service_id", $$v)},expression:"formData.third_party_service_id"}}),_c('BaseFormSelectFieldWithValidator',{attrs:{"validator":{
                name: 'phone number',
                vid: 'phone_number_id',
                rules: {
                  required: true,
                },
              },"field":{
                id: 'phone_number_id',
                label: 'To',
                required: true,
                defaultOptionLabel: 'Select contact phone...',
                options: _vm.phoneNumberOptions,
              },"disabled":formProps.isPending},model:{value:(_vm.formData.phone_number_id),callback:function ($$v) {_vm.$set(_vm.formData, "phone_number_id", $$v)},expression:"formData.phone_number_id"}}),_c('div',[_c('BaseFormTextareaFieldWithValidator',{attrs:{"validator":{
                  name: 'content',
                  vid: 'content',
                  rules: {
                    required: true,
                  },
                },"field":{
                  id: 'content',
                  label: 'Content',
                },"disabled":formProps.isPending},model:{value:(_vm.formData.sms_message_content),callback:function ($$v) {_vm.$set(_vm.formData, "sms_message_content", $$v)},expression:"formData.sms_message_content"}}),_c('div',{staticClass:"mt-2 text-xs text-teal-700"},[_c('span',[_vm._v(_vm._s(_vm.contentStats.totalChars)+" characters")]),_vm._v(" / "),_c('span'),_vm._v(_vm._s(_vm.contentStats.totalMessages)+" messages ")])],1)],1),_c('div',{staticClass:"bg-gray-50 p-4 rounded-b space-x-2"},[_c('BaseButton',{attrs:{"primary":"","small":"","disabled":formProps.invalid || formProps.isPending}},[_vm._v(" Send ")]),_c('BaseButton',{attrs:{"type":"button","ghost":"","small":"","disabled":formProps.isPending},on:{"click":_vm.onCancel}},[_vm._v(" Cancel ")])],1)])]}}],null,true)}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }